export default __webpack_public_path__ + "static/media/Bossa-Bold.acdf8bd9.woff";